// Report Builder exports are made by a background job, which leaves a bell
// entry for the user who asked: the file when it is ready, or the failure. A
// scheduled report that did not run leaves one for its owner.

export const REPORT_BUILDER_EXPORT = 'REPORT_BUILDER_EXPORT';
export const REPORT_BUILDER_EXPORT_FAILED = 'REPORT_BUILDER_EXPORT_FAILED';
export const REPORT_BUILDER_SCHEDULE = 'REPORT_BUILDER_SCHEDULE';

type NotificationLike = {
  notificationType?: string;
  fromId?: string;
  assignedTo?: string;
};

export const isReportExportType = (type?: string) =>
  type === REPORT_BUILDER_EXPORT || type === REPORT_BUILDER_EXPORT_FAILED;

// An admin's bell lists every admin entry of the tenant (NX-5603), other
// admins' exports too: only the user who asked gets the title and the file,
// which the backend serves to that user alone.
const isOwn = (
  item: NotificationLike | undefined,
  userId: string | undefined,
) => !!userId && item?.assignedTo === userId;

// The bell entry of a finished export names the export (`fromId`): a click
// asks for a fresh link to its file.
export const isReportExportNotification = (
  item: NotificationLike | undefined,
  userId: string | undefined,
) =>
  item?.notificationType === REPORT_BUILDER_EXPORT &&
  !!item.fromId &&
  isOwn(item, userId);

// The bell shows this above the entry's content ("<file> · <rows> rows").
export const reportExportTitle = (
  item: NotificationLike | undefined,
  userId: string | undefined,
) => {
  if (!isOwn(item, userId)) return null;
  if (item?.notificationType === REPORT_BUILDER_EXPORT) {
    return 'Your report export is ready';
  }
  if (item?.notificationType === REPORT_BUILDER_EXPORT_FAILED) {
    return 'Your report export failed';
  }
  if (item?.notificationType === REPORT_BUILDER_SCHEDULE) {
    return 'Your scheduled report was not sent';
  }
  return null;
};
